/*/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Autodesk Design Automation team for Inventor
////////////////////////////////////////////////////////////////////*/

import actionTypes from "../actions/parametersActions";

export const initialState = {};

// parametry ��r�d�owe�
export const getParameters = (projectId, state) => state[projectId];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.PARAMETERS_UPDATED: {
            return {
                ...state,
                [action.projectId]: action.parameters
            };
        }

        // RESZTA BEZ ZMIAN � reset i edycje robi updateParametersReducer
        default:
            return state;
    }
}
